import { ReactNode } from "react";
import { Country } from "../../api/types/constants";

export const countryItemTemplate = (country: Country): ReactNode => {
  return (
    <>
      <i className={`fi fi-${country.value.toLowerCase()}`} />
      {" "}
      {country.label}
    </>
  )
}

export const countryValueTemplate = (country: Country | null): ReactNode => {
  if (country) {
    return countryItemTemplate(country)
  }

  return <>&nbsp;</>
}

export const countryColumnTemplate = (countryCode: string | null): ReactNode => {
  if (countryCode) {
    return (
      <span className="nowrap">
        <i className={`fi fi-${countryCode.toLowerCase()}`} />
        {" "}
        {countryCode}
      </span>
    )
  }

  return ""
}
